module.exports = __webpack_public_path__ + "img/verification_success.2caa7304.png";